class SubscriptionHandler extends HTMLElement{
    constructor(){
        super();
        this.inputfield = this.querySelector(".form-container input");
        this.price = parseInt(this.getAttribute('data-price'));
        this.unitPrice = this.closest("safe-sticky").querySelector(`[data-block-type="price"] unit-price`);

        this.unitConversion = {
          g: 0.001,         // grams to kg
          kg: 1,
          ml: 0.001,        // milliliters to L
          l: 1,
        };
    }

    connectedCallback(){
        this.addEventListener('change', this.handleInputChange.bind(this));
    }

    handleInputChange(e){
        let currentInput = e.target;
        this.inputfield.name = currentInput.hasAttribute("data-single") ? "quantity" : "selling_plan";
        this.inputfield.value = currentInput.value;

        let label = currentInput.closest("label");
        let discount = parseInt(label.getAttribute("data-percentage"));
        let unitAmount = parseInt(label.getAttribute("data-unit-amount"));
        let unitLabel = label.getAttribute("data-unit-label");

        let pricePerPiece = (this.price * (1 - discount / 100)) / unitAmount;
        let discountedPrice = (this.price * (1 - discount / 100));
        
        currentInput.closest(".subscription-block").querySelector("[data-units]").innerText = `${this.formatMoney(pricePerPiece)} / ${unitLabel}`;
        currentInput.closest(".subscription-block").querySelector("[data-price]").innerText = `${this.formatMoney(discountedPrice)}`;


        this.priceField = this.closest("safe-sticky").querySelector("sale-price");

        if(this.unitPrice){
          const qty = parseFloat(this.unitPrice.dataset.qty); // 126
          const unit = this.unitPrice.dataset.unit;           // 'g'
          const targetUnit = this.unitPrice.dataset.targetUnit; // 'kg'
          const targetQuantity = parseFloat(this.unitPrice.dataset.targetQuantity); // 1
          const price = discountedPrice;

          this.priceField.innerHTML = this.formatMoney(discountedPrice);

          let calculatedPrice = this.pricePerUnit(price, qty, unit, targetUnit, targetQuantity);

          this.unitPrice.innerText = `${this.formatMoney(calculatedPrice)}/${targetUnit}`;
        }

    }

    pricePerUnit(price, qty, unit, targetUnit, targetQuantity){
        if (!this.unitConversion[unit] || !this.unitConversion[targetUnit]) {
          throw new Error(`Unsupported conversion from ${unit} to ${targetUnit}`);
        }
      
        const qtyInTargetUnit = qty * (this.unitConversion[unit] / this.unitConversion[targetUnit]);
        return (price / qtyInTargetUnit) * targetQuantity;
    }

    formatMoney = function(cents, format) {
        if (typeof cents == 'string') { cents = cents.replace('.',''); }
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = format || window.themeVariables.settings.moneyFormat;
      
        function defaultOption(opt, def) {
           return (typeof opt == 'undefined' ? def : opt);
        }
      
        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultOption(precision, 2);
          thousands = defaultOption(thousands, ',');
          decimal   = defaultOption(decimal, '.');
      
          if (isNaN(number) || number == null) { return 0; }
      
          number = (number/100.0).toFixed(precision);
      
          var parts   = number.split('.'),
              dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
              cents   = parts[1] ? (decimal + parts[1]) : '';
      
          return dollars + cents;
        }
      
        switch(formatString.match(placeholderRegex)[1]) {
          case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
        }
      
        return formatString.replace(placeholderRegex, value);
      };

}

customElements.define("subscription-handler", SubscriptionHandler);